(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop + 2) {
        this.closeMenuDisclosure();
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teetao-account-portal"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-teetao-account]').forEach((root) => {
    const loginGateway = root.querySelector('[data-account-login-gateway]');
    if (loginGateway) {
      const loginLink = loginGateway.querySelector('[data-account-login-link]');
      if (loginLink && loginGateway.dataset.designMode !== 'true' && !window.Shopify?.designMode) {
        const key = 'teetao-login-redirect:' + window.location.pathname;
        let recentlyRedirected = false;
        try {
          const previous = Number(window.sessionStorage.getItem(key));
          recentlyRedirected = previous > 0 && Date.now() - previous < 30000;
          if (!recentlyRedirected) window.sessionStorage.setItem(key, String(Date.now()));
        } catch (error) {}
        if (!recentlyRedirected) window.location.replace(loginLink.href);
      }
      return;
    }
    try { window.sessionStorage.removeItem('teetao-login-redirect:' + window.location.pathname); } catch (error) {}
    const tabs = [...root.querySelectorAll('[data-account-tab]')];
    const panels = [...root.querySelectorAll('[data-account-panel]')];
    const shortcuts = [...root.querySelectorAll('[data-open-tab]')];
    const profileDialog = root.querySelector('[data-profile-dialog]');
    const profileOpeners = [...root.querySelectorAll('[data-profile-modal-open]')];
    const profileViews = profileDialog ? [...profileDialog.querySelectorAll('[data-profile-view]')] : [];
    const pointsBalance = root.querySelector('[data-smile-points-balance]');
    let syncPending = false;
    let lastSync = 0;

    const loadSmileBalance = async () => {
      if (!root.isConnected || document.hidden || syncPending || !pointsBalance) return false;
      if (!window.Smile?.customerPointsWallet?.get) {
        return false;
      }
      syncPending = true;

      try {
        const wallet = await window.Smile.customerPointsWallet.get();
        const balance = wallet?.balance;
        if (typeof balance !== 'number' || !Number.isFinite(balance)) throw new Error('Invalid wallet');
        pointsBalance.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en').format(balance);
        pointsBalance.dataset.state = 'ready';
        lastSync = Date.now();
        return true;
      } catch (error) {
        pointsBalance.dataset.state = 'unavailable';
        return false;
      } finally {
        syncPending = false;
      }
    };

    document.addEventListener('smile-js-initialized', loadSmileBalance);
    window.addEventListener('focus', loadSmileBalance);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) loadSmileBalance();
    });
    const syncTimer = window.setInterval(() => {
      if (!root.isConnected) return window.clearInterval(syncTimer);
      if (Date.now() - lastSync >= 15000) loadSmileBalance();
    }, 15000);
    loadSmileBalance();

    let smileSdkRequest;

    const requestSmileSdk = () => {
      if (window.Smile?.customerPointsWallet?.get) return Promise.resolve(true);
      if (smileSdkRequest) return smileSdkRequest;

      smileSdkRequest = new Promise((resolve) => {
        let attempts = 0;
        let sdkRequested = false;

        const checkSdk = async () => {
          if (window.Smile?.customerPointsWallet?.get) {
            resolve(true);
            return;
          }

          if (!sdkRequested && typeof window.loadSmileSdk === 'function') {
            sdkRequested = true;
            try {
              await window.loadSmileSdk();
            } catch (error) {
              // The timed checks below still allow Smile's lifecycle event to finish.
            }
          }

          attempts += 1;
          if (attempts >= 40) {
            resolve(false);
            return;
          }

          window.setTimeout(checkSdk, 200);
        };

        document.addEventListener('smile-lite-loaded', checkSdk, {once: true});
        document.addEventListener('smile-js-initialized', checkSdk, {once: true});
        checkSdk();
      });

      return smileSdkRequest;
    };

    requestSmileSdk().then((ready) => { if (ready) loadSmileBalance(); });

    const referralShare = root.querySelector('[data-referral-share]');
    const referralInput = root.querySelector('[data-referral-url]');
    const referralStatus = root.querySelector('[data-referral-status]');
    const loadReferral = () => {
      if (!referralShare || !referralInput || !referralStatus) return;
      try {
        const member = window.Smile?.customer?.current?.();
        const url = new URL(member?.referralUrl);
        if (!['https:', 'http:'].includes(url.protocol)) throw new Error('Invalid referral URL');
        referralInput.value = url.href;
        referralShare.hidden = false;
        referralStatus.textContent = referralStatus.dataset.ready;
      } catch {
        referralInput.value = '';
        referralShare.hidden = true;
        referralStatus.textContent = referralStatus.dataset.unavailable;
      }
    };
    root.querySelector('[data-referral-copy]')?.addEventListener('click', async () => {
      if (!referralInput?.value) return;
      try {
        await navigator.clipboard.writeText(referralInput.value);
        referralStatus.textContent = referralStatus.dataset.copied;
      } catch {
        referralInput.focus();
        referralInput.select();
        referralStatus.textContent = referralStatus.dataset.copyError;
      }
    });
    document.addEventListener('smile-js-initialized', loadReferral);
    window.addEventListener('focus', loadReferral);
    requestSmileSdk().then(loadReferral);

    const showProfileView = (name) => {
      profileViews.forEach((view) => {
        view.hidden = view.dataset.profileView !== name;
      });
    };

    const openProfileDialog = (view = 'overview') => {
      if (!profileDialog) return;
      showProfileView(view);
      profileDialog.showModal();
    };

    profileOpeners.forEach((button) => button.addEventListener('click', () => openProfileDialog(button.dataset.profileModalOpen)));

    if (profileDialog) {
      profileDialog.querySelector('[data-profile-modal-close]')?.addEventListener('click', () => profileDialog.close());
      profileDialog.querySelectorAll('[data-profile-detail]').forEach((button) => button.addEventListener('click', () => showProfileView(button.dataset.profileDetail)));
      profileDialog.querySelectorAll('[data-profile-back]').forEach((button) => button.addEventListener('click', () => showProfileView('overview')));
      profileDialog.addEventListener('click', (event) => {
        if (event.target === profileDialog) profileDialog.close();
      });
      profileDialog.addEventListener('close', () => showProfileView('overview'));
    }

    const openPanel = (name, updateHash = true) => {
      const target = panels.find((panel) => panel.dataset.accountPanel === name);
      if (!target) return;

      tabs.forEach((tab) => {
        const active = tab.dataset.accountTab === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const active = panel === target;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      if (updateHash) history.replaceState(null, '', `#${name}`);
      root.scrollIntoView({behavior: 'smooth', block: 'start'});
    };

    tabs.forEach((tab) => tab.addEventListener('click', () => openPanel(tab.dataset.accountTab)));
    shortcuts.forEach((button) => button.addEventListener('click', () => openPanel(button.dataset.openTab)));

    const initial = window.location.hash.replace('#', '');
    if (initial) openPanel(initial, false);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teetao-migration-notice"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('teetao-migration-notice')) {
    customElements.define('teetao-migration-notice', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.key = 'teetao-migration-notice-2026-v1';
        this.editor = this.dataset.editor === 'true';
        this.querySelectorAll('[data-dismiss]').forEach(button => button.addEventListener('click', () => this.dismiss()));
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); });
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const rect = this.dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dismiss(); } });
        this.dialog.addEventListener('close', () => document.documentElement.classList.remove('tt-migration-open'));
        this.selectHandler = event => { if (event.target.contains(this)) this.open(); };
        this.deselectHandler = event => { if (event.target.contains(this)) this.dialog.close(); };
        if (this.editor) {
          document.addEventListener('shopify:section:select', this.selectHandler);
          document.addEventListener('shopify:section:deselect', this.deselectHandler);
          if (this.dataset.preview === 'true') this.open();
        } else {
          let dismissed = false;
          try { dismissed = sessionStorage.getItem(this.key) === 'dismissed'; } catch {}
          if (!dismissed) this.timer = setTimeout(() => this.open(), 600);
        }
      }
      open() {
        if (!this.isConnected || this.dialog.open) return;
        this.dialog.showModal();
        document.documentElement.classList.add('tt-migration-open');
        this.dialog.querySelector('h2').focus();
      }
      dismiss() {
        if (!this.editor) { try { sessionStorage.setItem(this.key, 'dismissed'); } catch {} }
        this.dialog.close();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('shopify:section:select', this.selectHandler);
        document.removeEventListener('shopify:section:deselect', this.deselectHandler);
        document.documentElement.classList.remove('tt-migration-open');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
